import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';

import { useState } from 'react';

import PreviewTable from './checkin/previewTable';
import ReportParameters from './checkin/reportParameters';

const CheckInLog = ({ tabValue, location }) => {
   const [processing, setProcessing] = useState(false);
   const [loadedData, setLoadedData] = useState(false);

   return (
      <Box py={4}>
         <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
               <ReportParameters
                  loadedData={loadedData}
                  setLoadedData={setLoadedData}
                  location={location}
                  processing={processing}
                  setProcessing={setProcessing}
               />
            </Grid>
            <Grid item xs={12} sm={8}>
               <PreviewTable loadedData={loadedData} processing={processing} />
            </Grid>
         </Grid>
      </Box>
   );
};

export default CheckInLog;
